<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div class="loadertext" v-if="this.isLoading">
      {{ $t("loadingTxt") }}...
    </div>
    <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
      <!--begin::navbar-->
      <navbar-component></navbar-component>
      <!--end::navbar-->

      <div class="page-wrapper">
        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div>
              <h4 class="mb-12 mb-md-0"></h4>
            </div>

            <div class="col-lg-12 col-xl-12 stretch-card">
              <div class="card">
                <div class="card-header">
                  <div class="row mb-3">
                    <h4 style="margin-right: 5px" class="float-start">
                      {{ $t("cmlDetailSubStorage") }}
                    </h4>
                  </div>

                  <div class="card-body">
                    <div class="row mb-3">
                      <div class="col-md-3">
                        <label class="form-label">{{
                          $t("idDetailStorage")
                        }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="idDetailStorage"
                          :placeholder="$t('idDetailStorage')"
                          v-model="forms.idDetailStorage"
                          disabled />
                      </div>
                      <div class="col-md-3">
                        <label class="form-label">{{
                          $t("idBillingDetail")
                        }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="idBillingDetail"
                          :placeholder="$t('idBillingDetail')"
                          v-model="forms.idBillingDetail"
                          disabled />
                      </div>
                      <div class="col-md-3">
                        <label class="form-label">{{
                          $t("locationCategory")
                        }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="locationCategory"
                          :placeholder="$t('locationCategory')"
                          v-model="forms.locationCategory"
                          disabled />
                      </div>
                      <div class="col-md-3">
                        <label class="form-label">{{ $t("zone") }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="zone"
                          :placeholder="$t('zone')"
                          v-model="forms.zone"
                          disabled />
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-md-3">
                        <label class="form-label">{{
                          $t("keyLocation")
                        }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="keyLocation"
                          :placeholder="$t('keyLocation')"
                          v-model="forms.keyLocation"
                          disabled />
                      </div>
                      <div class="col-md-3">
                        <label class="form-label">{{ $t("uom") }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="uom"
                          :placeholder="$t('uom')"
                          v-model="forms.UOM"
                          disabled />
                      </div>
                      <div class="col-md-6">
                        <label class="form-label">{{
                          $t("rateBaseDesc_txt")
                        }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="rateBaseDesc"
                          :placeholder="$t('rateBaseDesc_txt')"
                          v-model="forms.rateBaseDesc"
                          disabled />
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-md-3">
                        <label class="form-label">{{ $t("qty_txt") }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="qty"
                          :placeholder="$t('qty_txt')"
                          v-model="forms.qty"
                          disabled />
                      </div>
                      <div class="col-md-3">
                        <label class="form-label">{{ $t("rate") }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="rate"
                          :placeholder="$t('rate')"
                          v-model="forms.rate"
                          disabled />
                      </div>
                      <div class="col-md-6">
                        <label class="form-label">{{ $t("amount_txt") }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="amount"
                          :placeholder="$t('amount_txt')"
                          v-model="forms.amount"
                          disabled />
                      </div>
                    </div>
                  </div>

                  <button
                    v-if="permision_role.method_read"
                    class="btn btn-success float-end btn-xs"
                    style="margin-right: 5px"
                    @click.prevent="downloadData()">
                    <span class="mdi mdi-download h4"></span>
                    {{ $t("downloadData") }} .xlsx
                  </button>

                  <button
                    class="btn btn-primary text-light fw-bolder btn-icon-text"
                    @click="backForm"
                    type="button">
                    <i class="link-icon mdi mdi-arrow-left"></i>
                    {{ $t("backMess") }}
                  </button>
                </div>

                <div
                  class="card-body"
                  v-if="this.formsHeader.status === 'COMPLETED'">
                  <vue-good-table
                    title="list-billing-cml-billing-sub-detail-storage-sub-detail-storage"
                    ref="list-billing-cml-billing-sub-detail-storage-sub-detail-storage"
                    mode="remote"
                    styleClass="vgt-table striped"
                    :select-options="{
                      enabled: true,
                      selectOnCheckboxOnly: true,
                      selectionText: $t('data_selected'),
                      clearSelectionText: $t('clear'),
                    }"
                    @on-selected-rows-change="selectionChanged"
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    :totalRows="totalRecords"
                    :line-numbers="true"
                    :isLoading.sync="isLoading"
                    :pagination-options="{
                      enabled: true,
                      perPageDropdown: [10, 50, 100, 1000, 10000],
                      dropdownAllowAll: false,
                      //position: 'top',
                    }"
                    :rows="rows"
                    :columns="columns">
                    <div slot="table-actions">
                      {{ $t("no_select_data") }}
                    </div>
                    <div slot="selected-row-actions">
                      <button
                        class="btn btn-danger btn-xs"
                        style="margin-right: 20px"
                        @click="selectionChangeStatus">
                        <i class="mdi mdi-send-outline"></i>
                        {{ $t("changeStatus") }}
                      </button>

                      <button
                        class="btn btn-success btn-xs"
                        @click="removeSelections">
                        <i class="mdi mdi-close"></i>
                        {{ $t("unselect_data_txt") }}
                      </button>
                    </div>

                    <template slot="column-filter" slot-scope="{ column }">
                      <span v-if="column.filterOptions.customFilter">
                        <span v-if="column.field == 'stockDate'">
                          <date-range-picker
                            style="width: 100%"
                            @update="stockDateChange"
                            control-container-class="form-control"
                            :locale-data="{ format: 'yyyy-mm-dd' }"
                            v-model="stockDate"
                            :opens="opens"
                            :singleDatePicker="false"
                            :timePicker24Hour="false"
                            :timePicker="false"
                            :showWeekNumbers="false">
                            <div slot="header" slot-scope="header" class="slot">
                              <a
                                @click="clearstockDateChange()"
                                class="float-end"
                                style="margin-right: 5px; color: red"
                                >Clear Calendar</a
                              >
                              <span v-if="header.in_selection">
                                - in selection</span
                              >
                              <br />
                            </div>
                          </date-range-picker>
                        </span>
                      </span>
                    </template>

                    <template slot="table-row" slot-scope="props">
                      <span v-if="props.column.field == 'actions'">
                        <a
                          href="#"
                          v-if="
                            permision_role.method_update &&
                            props.row.status === 'BILL'
                          "
                          title="NOT BILL"
                          @click.prevent="
                            changeStatusData(props.index, props.row, 'NOT BILL')
                          ">
                          <button class="btn btn-danger btn-xs">
                            NOT BILL
                          </button>
                        </a>
                        <a
                          href="#"
                          v-else
                          @click.prevent="
                            changeStatusData(props.index, props.row, 'BILL')
                          ">
                          <button class="btn btn-primary btn-xs">BILL</button>
                        </a>
                      </span>
                      <span v-else-if="props.column.field == 'amount'">
                        {{ toCurrency(props.row.amount) }}
                      </span>
                      <span v-else-if="props.column.field == 'rate'">
                        {{ toCurrency(props.row.rate) }}
                      </span>
                      <span v-else-if="props.column.field == 'status'">
                        <span
                          v-if="props.row.status == 'BILL'"
                          class="badge bg-primary"
                          ><h5>{{ props.row.status }}</h5></span
                        >
                        <span v-else class="badge bg-danger"
                          ><h5>{{ props.row.status }}</h5></span
                        >
                      </span>
                      <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                      </span>
                    </template>
                  </vue-good-table>
                </div>

                <div class="card-body" v-else>
                  <vue-good-table
                    title="list-billing-cml-billing-sub-detail-storage-sub-detail-storage"
                    ref="list-billing-cml-billing-sub-detail-storage-sub-detail-storage"
                    mode="remote"
                    styleClass="vgt-table striped"
                    :select-options="{
                      enabled: true,
                      selectOnCheckboxOnly: true,
                      selectionText: $t('data_selected'),
                      clearSelectionText: $t('clear'),
                    }"
                    @on-selected-rows-change="selectionChanged"
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    :totalRows="totalRecords"
                    :line-numbers="true"
                    :isLoading.sync="isLoading"
                    :pagination-options="{
                      enabled: true,
                      perPageDropdown: [10, 50, 100, 1000, 10000],
                      dropdownAllowAll: false,
                      //position: 'top',
                    }"
                    :rows="rows"
                    :columns="columns">
                    <div slot="table-actions">
                      {{ $t("no_select_data") }}
                    </div>

                    <template slot="column-filter" slot-scope="{ column }">
                      <span v-if="column.filterOptions.customFilter">
                        <span v-if="column.field == 'stockDate'">
                          <date-range-picker
                            style="width: 100%"
                            @update="stockDateChange"
                            control-container-class="form-control"
                            :locale-data="{ format: 'yyyy-mm-dd' }"
                            v-model="stockDate"
                            :opens="opens"
                            :singleDatePicker="false"
                            :timePicker24Hour="false"
                            :timePicker="false"
                            :showWeekNumbers="false">
                            <div slot="header" slot-scope="header" class="slot">
                              <a
                                @click="clearstockDateChange()"
                                class="float-end"
                                style="margin-right: 5px; color: red"
                                >Clear Calendar</a
                              >
                              <span v-if="header.in_selection">
                                - in selection</span
                              >
                              <br />
                            </div>
                          </date-range-picker>
                        </span>
                      </span>
                    </template>

                    <template slot="table-row" slot-scope="props">
                      <span v-if="props.column.field == 'amount'">
                        {{ toCurrency(props.row.amount) }}
                      </span>
                      <span v-else-if="props.column.field == 'rate'">
                        {{ toCurrency(props.row.rate) }}
                      </span>
                      <span v-else-if="props.column.field == 'status'">
                        <span
                          v-if="props.row.status == 'BILL'"
                          class="badge bg-primary"
                          ><h5>{{ props.row.status }}</h5></span
                        >
                        <span v-else class="badge bg-danger"
                          ><h5>{{ props.row.status }}</h5></span
                        >
                      </span>
                      <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                      </span>
                    </template>
                  </vue-good-table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>

<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import DateRangePicker from "vue2-daterange-picker";

export default {
  name: "CmlBillingSubDetailStorage",
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    DateRangePicker,
  },
  data() {
    return {
      opens: "center",
      locale: {
        format: "yyyy-mm-dd",
      },
      stockDate: {
        startDate: null,
        endDate: null,
      },
      firstDates: {
        startDate: null,
        endDate: null,
      },
      highlighted: {
        dates: [
          // Highlight an array of dates
          new Date(),
        ],
      },
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      isLoading: false,
      errors: [],
      permision_role: [],
      langs: ["id", "en"],
      detailUser: [],
      idBillingHeader: [],
      detailDivisi: [],
      totalRecords: 0,
      stockDateFrom: "",
      firstBilingDate: "",
      stockDateTo: "",
      serverParams: {
        columnFilters: {},
        sort: {
          field: "",
          type: "",
        },
        page: 1,
        per_page: 10,
      },
      columns: [
        {
          label: this.$t("idSubDetailStorage"),
          field: "idSubDetailStorage",
          thClass: "text-center",
          width: "100px",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("idSubDetailStorage"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("statusTxt"),
          field: "status",
          thClass: "text-center",
          width: "100px",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("statusTxt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: ["BILL", "NOT BILL"], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: this.$t("skuCodeTxt"),
          field: "sku",
          thClass: "text-center",
          width: "150px",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("skuCodeTxt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("skuDescriptionTxt"),
          field: "skuDesc",
          thClass: "text-center",
          width: "230px",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("skuDescriptionTxt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: this.$t("stockDate"),
          field: "stockDate",
          thClass: "text-center",
          width: "150px",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: true,
            placeholder: this.$t("stockDate"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("qty_txt"),
          field: "qty",
          thClass: "text-center",
          width: "100px",
          filterOptions: {
            enabled: false, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("qty_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: this.$t("rate"),
          field: "rate",
          thClass: "text-center",
          width: "100px",
          filterOptions: {
            enabled: false, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("rate"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: this.$t("amount_txt"),
          field: "amount",
          thClass: "text-center",
          width: "100px",
          filterOptions: {
            enabled: false, // enable filter for this column
            customFilter: false,
          },
        },

        {
          label: this.$t("action_txt"),
          field: "actions",
          thClass: "text-center",
          width: "100px",
          sortable: false,
          filterOptions: {
            customFilter: false,
            enabled: false,
          },
        },
        {
          label: this.$t("additionalFlag"),
          field: "additionalFlag",
          thClass: "text-center",
          width: "100px",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("all"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: ["Y", "N"], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: this.$t("locationCategory"),
          field: "locationCategory",
          thClass: "text-center",
          width: "100px",
          filterOptions: {
            enabled: false, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("locationCategory"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: this.$t("locationId"),
          field: "locationId",
          thClass: "text-center",
          width: "100px",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("locationId"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("traceId"),
          field: "traceId",
          thClass: "text-center",
          width: "100px",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("traceId"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("MUID"),
          field: "MUID",
          thClass: "text-center",
          width: "100px",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("MUID"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: this.$t("batch"),
          field: "batch",
          thClass: "text-center",
          width: "100px",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("batch"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("lotAtt07"),
          field: "lotAtt07",
          thClass: "text-center",
          width: "100px",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("lotAtt07"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: this.$t("qtyEach"),
          field: "qtyEach",
          thClass: "text-center",
          width: "100px",
          filterOptions: {
            enabled: false, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("qtyEach"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: this.$t("qtyOnHand"),
          field: "qtyOnHand",
          thClass: "text-center",
          width: "100px",
          filterOptions: {
            enabled: false, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("qtyOnHand"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("uom"),
          field: "UOM",
          thClass: "text-center",
          width: "100px",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("uom"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("cube"),
          field: "Cube",
          thClass: "text-center",
          width: "100px",
          filterOptions: {
            enabled: false, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("cube"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: this.$t("totalCube"),
          field: "totalCube",
          thClass: "text-center",
          width: "100px",
          filterOptions: {
            enabled: false, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("totalCube"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: this.$t("qtyOnCases"),
          field: "qtyOnCases",
          thClass: "text-center",
          width: "100px",
          filterOptions: {
            enabled: false, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("qtyOnCases"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: this.$t("qtyPerPallet"),
          field: "qtyPallet",
          thClass: "text-center",
          width: "100px",
          filterOptions: {
            enabled: false, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("qtyPerPallet"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
      ],
      rows: [],
      rowsSelection: [],
      idCodeLkupsSelections: [],
      forms: {
        rateBaseDesc: "",
        idDetailStorage: "",
        idBillingDetail: "",
        locationCategory: "",
        zone: "",
        rate: "",
        qty: "",
        UOM: "",
        amount: "",
        addwho: "",
        editwho: "",
        keyLocation: "",
        rateBaseName: "",
      },
      formsDetail: {
        idBillingDetail: "",
        idBillingHeader: "",
        chargeCategory: "",
        chargeType: "",
        SAPMaterialCode: "",
        SAPDivision: "",
        amountCategory: "",
        addwho: "",
        editwho: "",
        qtyCharge: "",
        rate: "",
      },
      formsHeader: {
        idBillingHeader: "",
        tariffId: "",
        customerId: "",
        warehouseId: "",
        transactionToDate: "",
        transactionFromDate: "",
        status: "",
        amount: "",
        idRateHeader: "",
        transactionDate: "",
        addwho: "",
        editwho: "",
        adddate: "",
        editdate: "",
      },
    };
  },
  watch: {},
  methods: {
    changeStatusData(index, row, statusNya) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourData"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          var formData = {
            idBillingHeader: this.formsHeader.idBillingHeader,
            idBillingDetail: this.formsDetail.idBillingDetail,
            idDetailStorage: this.forms.idDetailStorage,
            idSubDetailStorages: [row.idSubDetailStorage],
            status: statusNya,
          };
          const baseURI =
            this.$settings.endPointBilling +
            "dashboard/cml-billing/billing/bt-billing-detail-detail-sub-detail-storage-update-status";
          this.$http
            .post(baseURI, formData, { timeout: 60000 })
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                this.loadItems();
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();

              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));
              } else {
                if (error.response) {
                  if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                  } else if (error.response.status === 401) {
                    this.logout();
                  } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                  } else if (error.response.status === 500) {
                    this.$router.push("/server-error");
                  } else {
                    this.$router.push("/page-not-found");
                  }
                }
              }
            });
        } else {
          this.isLoading = false;
        }
      });
    },

    selectionChangeStatus() {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataSend"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "BILL",
        cancelButtonText: "NOT BILL",
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;

          let formData = {
            idBillingHeader: this.formsHeader.idBillingHeader,
            idBillingDetail: this.formsDetail.idBillingDetail,
            idDetailStorage: this.forms.idDetailStorage,
            idSubDetailStorages: this.idCodeLkupsSelections,
            status: "BILL",
          };
          const baseURI =
            this.$settings.endPointBilling +
            "dashboard/cml-billing/billing/bt-billing-detail-detail-sub-detail-storage-update-status";
          this.$http
            .post(baseURI, formData, { timeout: 60000 })
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                this.idCodeLkupsSelections = [];
                this.loadItems();
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();

              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));
              } else {
                if (error.response) {
                  if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                  } else if (error.response.status === 401) {
                    this.logout();
                  } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                  } else if (error.response.status === 500) {
                    this.$router.push("/server-error");
                  } else {
                    this.$router.push("/page-not-found");
                  }
                }
              }
            });
        } else {
          this.isLoading = true;
          let formData = {
            idBillingHeader: this.formsHeader.idBillingHeader,
            idBillingDetail: this.formsDetail.idBillingDetail,
            idDetailStorage: this.forms.idDetailStorage,
            idSubDetailStorages: this.idCodeLkupsSelections,
            status: "NOT BILL",
          };
          const baseURI =
            this.$settings.endPointBilling +
            "dashboard/cml-billing/billing/bt-billing-detail-detail-sub-detail-storage-update-status";
          this.$http
            .post(baseURI, formData, { timeout: 60000 })
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                this.idCodeLkupsSelections = [];
                this.loadItems();
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();

              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));
              } else {
                if (error.response) {
                  if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                  } else if (error.response.status === 401) {
                    this.logout();
                  } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                  } else if (error.response.status === 500) {
                    this.$router.push("/server-error");
                  } else {
                    this.$router.push("/page-not-found");
                  }
                }
              }
            });
        }
      });
    },

    removeSelections() {
      this.idCodeLkupsSelections = [];
      this.$refs[
        "list-billing-cml-billing-sub-detail-storage-sub-detail-storage"
      ].unselectAllInternal();
    },

    selectionChanged(ev) {
      this.rowsSelection = [];
      this.idCodeLkupsSelections = [];
      this.rowsSelection = ev.selectedRows;

      this.rowsSelection.forEach((item) => {
        this.idCodeLkupsSelections.push(item.idSubDetailStorage);
      });
    },

    stockDateChange() {
      if (this.stockDate.startDate && this.stockDate.endDate) {
        this.stockDateFrom = this.$moment(
          String(this.stockDate.startDate)
        ).format("YYYY-MM-DD");
        this.stockDateTo = this.$moment(String(this.stockDate.endDate)).format(
          "YYYY-MM-DD"
        );
        this.loadItems();
      }
    },

    clearstockDateChange() {
      this.stockDate = {
        startDate: null,
        endDate: null,
      };
      this.stockDateFrom = "";
      this.stockDateTo = "";
      this.loadItems();
    },

    backForm() {
      var params = this.$onRandom(this.$route.params.idBillingDetail);
      window.location.href =
        "/billing-cml/billing/detail-storage/" +
        params +
        "/" +
        this.$route.params.idBillingHeader;
    },

    toCurrency(value) {
      if (typeof value !== "number") {
        return value;
      }
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "IDR",
      });
      return formatter.format(value);
    },

    downloadData() {
      let stockDateFrom = this.stockDateFrom;
      let stockDateTo = this.stockDateTo;
      var params = this.$onBehind(this.$route.params.idDetailStorage);
      const baseURI =
        this.$settings.endPointBilling +
        "dashboard/cml-billing/billing/bt-billing-detail-detail-sub-detail-storage/" +
        params[0];
      this.isLoading = true;
      var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      var file_name = "download_" + CurrentDate + ".xlsx";

      return this.$http
        .get(
          baseURI +
            `?additionalFlag=${this.serverParams.columnFilters.additionalFlag}&lotAtt07=${this.serverParams.columnFilters.lotAtt07}&batch=${this.serverParams.columnFilters.batch}&idSubDetailStorage=${this.serverParams.columnFilters.idSubDetailStorage}&sku=${this.serverParams.columnFilters.sku}&UOM=${this.serverParams.columnFilters.UOM}&status=${this.serverParams.columnFilters.status}&skuDesc=${this.serverParams.columnFilters.skuDesc}&traceId=${this.serverParams.columnFilters.traceId}&locationId=${this.serverParams.columnFilters.locationId}&MUID=${this.serverParams.columnFilters.MUID}&stockDateFrom=${stockDateFrom}&stockDateTo=${stockDateTo}&download=download`,
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          this.isLoading = false;
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        });
    },

    // load items is what brings back the rows from server
    loadItems() {
      let stockDateFrom = this.stockDateFrom;
      let stockDateTo = this.stockDateTo;

      var params = this.$onBehind(this.$route.params.idDetailStorage);
      const baseURI =
        this.$settings.endPointBilling +
        "dashboard/cml-billing/billing/bt-billing-detail-detail-sub-detail-storage/" +
        params[0];
      this.isLoading = true;

      return this.$http
        .get(
          baseURI +
            `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&idSubDetailStorage=${this.serverParams.columnFilters.idSubDetailStorage}&sku=${this.serverParams.columnFilters.sku}&UOM=${this.serverParams.columnFilters.UOM}&status=${this.serverParams.columnFilters.status}&skuDesc=${this.serverParams.columnFilters.skuDesc}&traceId=${this.serverParams.columnFilters.traceId}&locationId=${this.serverParams.columnFilters.locationId}&MUID=${this.serverParams.columnFilters.MUID}&stockDateFrom=${stockDateFrom}&stockDateTo=${stockDateTo}&lotAtt07=${this.serverParams.columnFilters.lotAtt07}&batch=${this.serverParams.columnFilters.batch}&additionalFlag=${this.serverParams.columnFilters.additionalFlag}`,
          { timeout: 60000 }
        )
        .then((response) => {
          this.isLoading = false;
          this.rows = response.data.datas.data;
          this.totalRecords = response.data.datas.total;
        })
        .catch((error) => {
          this.loading();

          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

    logout() {
      const baseURI = this.$settings.endPoint + "user/logout";
      this.$http.get(baseURI, { timeout: 60000 }).then((response) => {
        console.log(response);
      });

      this.$logoutUser();
      window.location.href = "/";
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
      this.loadItems();
    },

    onColumnFilter(params) {
      this.updateParams(params);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
    },

    onPerPageChange(params) {
      this.updateParams({ per_page: params.currentPerPage });
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.isLoading = false;
      }, 1000); // hide the message after 3 seconds
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == "BillingCmlController") {
          rolePermision = permision;
        }
      });

      if (!rolePermision.method_read) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;

      this.loadData();
    },

    loadData() {
      this.isLoading = true;

      var params = this.$onBehind(this.$route.params.idDetailStorage);

      const baseURI =
        this.$settings.endPointBilling +
        "dashboard/cml-billing/billing/bt-billing-detail-detail-detail-storage/" +
        params[0];
      return this.$http
        .get(baseURI, { timeout: 60000 })
        .then((response) => {
          this.isLoading = false;
          this.forms = response.data.datas;
          this.forms.amount = this.toCurrency(response.data.datas.amount);
          this.forms.rate = this.toCurrency(response.data.datas.rate);
          this.formsDetail = response.data.datas.bm_billing_detail;
          this.formsHeader =
            response.data.datas.bm_billing_detail.bm_billing_header;
        })
        .catch((error) => {
          this.isLoading = false;

          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },
  },
  events: {},
  created: function () {},
  mounted() {
    this.fetchIt();
    this.loading();
  },
};
</script>
<style scoped>
.blur-content {
  filter: blur(5px);
}
</style>
